import { getLocation } from '@jfs/utils'
import { flow, types } from 'mobx-state-tree'
import { AGENT_STATUS } from '../../AppContants'
import { addAgentUserIdentity, getaddAgentRequest } from '../../network/addAgentUserIdentity'
import {
  authenticateOtp,
  getAgentAuthenticationRquest,
  getAuthenticateOtpForBiometric,
} from '../../network/authenticateOtp'
import { downloadReceipt } from '../../network/downloadReceipt'
import { generateOtp, getOtpRequest, getOtpRequestRefund } from '../../network/generateOtp'
import { getAgentBankDetails } from '../../network/getAgentBankDetails'
import { getAgentUserInformation } from '../../network/getAgentUserInformation'
import { getUniqueDeviceSession } from '../../network/getUniqueDeviceSession'
import { sendUniqueDeviceSession } from '../../network/sendUniqueDeviceSession'
import { RootStore } from '../store'
import { getAuthenticateOtpForAgent } from './../../network/authenticateOtp'
import { Session, sessionData } from './Session'

const Aadhaar = types.model('Aadhaar', {
  tokenPresent: types.optional(types.boolean, false),
  maskedValue: types.optional(types.string, ''),
  token: types.optional(types.string, ''),
  UIDToken: types.optional(types.string, ''),
  referenceNumber: types.optional(types.string, ''),
  jpbToken: types.maybeNull(types.string),
})

const AgentAuthorization = types.model('AgentAuthorization', {
  function: types.optional(types.number, -1),
  accountType: types.optional(types.number, -1),
  accountHolderType: types.optional(types.number, -1),
  kycType: types.optional(types.number, -1),
  allowed: types.optional(types.boolean, false),
})

const AgentDetails = types.model('AgentDetails', {
  name: types.maybeNull(types.string),
  id: types.maybeNull(types.string),
  city: types.maybeNull(types.string),
  stateCode: types.maybeNull(types.string),
  pinCode: types.maybeNull(types.union(types.string, types.number)), // Handles both types
  latitude: types.maybeNull(types.number),
  longitude: types.maybeNull(types.number),
  address: types.maybeNull(types.string), // <--- This captures the full address string
})

export const AgentInfo = types.model('AgentInfo', {
  agentUserLoginId: types.optional(types.string, ''),
  agentUserName: types.optional(types.string, ''),
  gender: types.optional(types.number, -1),
  dob: types.optional(types.string, ''),
  parentOnboardingId: types.maybeNull(types.string),
  agentMobileNumber: types.optional(types.string, ''),
  agentEmailId: types.maybeNull(types.string),
  mobileCountryCode: types.optional(types.number, 91),
  agentStatus: types.optional(types.number, -1),
  adminUser: types.optional(types.boolean, false),
  agentAuthorization: types.maybeNull(types.array(AgentAuthorization)),
  agentUserStateCode: types.maybeNull(types.string),
  agentUserCity: types.maybeNull(types.string),
  agentUserPincode: types.maybeNull(types.string),
  agentUserRoleType: types.optional(types.number, -1),
  agentUserDealershipName: types.optional(types.string, ''),
  agentUserDealerCity: types.maybeNull(types.string),
  agentUserDealerState: types.maybeNull(types.string),
  agentUserDealerPinCode: types.maybeNull(types.string),
  agentUserDealerStoreCode: types.maybeNull(types.string),
  authorizationCode: types.maybeNull(types.string),
  agent: types.maybeNull(AgentDetails),
  aadhaar: Aadhaar,
  panNumber: types.maybeNull(types.string),
  entityType: types.maybeNull(types.string),
})

export const DeviceInfo = types.model('DeviceInfo', {
  latitude: types.optional(types.string, ''),
  longitude: types.optional(types.string, ''),
  version: types.optional(types.string, ''),
  appId: types.optional(types.string, ''),
  appName: types.optional(types.string, ''),
  id: types.optional(types.string, ''),
  ip: types.optional(types.string, ''),
  osType: types.optional(types.string, ''),
  osVer: types.optional(types.string, ''),
  model: types.optional(types.string, ''),
  sdkVersion: types.optional(types.string, ''),
  biometricDeviceInfo: types.optional(types.string, '{}'),
})

const Agent = types
  .model('Agent', {
    isAadhaarVarified: types.optional(types.boolean, false),
    session: Session,
    agentInfo: AgentInfo,
    CLIENT_ID: types.optional(types.string, ''),
    deviceInfo: DeviceInfo,
    type: types.maybeNull(types.string),
    encToken: types.maybeNull(types.string),
    encKey: types.maybeNull(types.string),
    parentOrigin: types.maybeNull(types.string),
    transactionType: types.maybeNull(types.string),
    otpReferenceId: types.optional(types.string, ''),
    // otpReferenceId: types.optional(types.string, ''),
  })
  .actions((self) => ({
    updateIsAadhaarVarified: function updateIsAadhaarVarified() {
      self.isAadhaarVarified = true
      return true
    },
    updateOtpReferenceId: function updateOtpReferenceId(id: string) {
      self.otpReferenceId = id;
    },
    clearOtpReferenceId() {
      self.otpReferenceId = '';
      // console.log('✅ Agent otpReferenceId has been cleared.');
    },
    getAgentUserInformationApi: flow(function* getAgentUserInformationApi() {
      try {
        const res = yield getAgentUserInformation(self.session, self.agentInfo.agentUserLoginId)
        console.log(res, 'getAgentUserInformationApiRes')
        self.agentInfo = res
        // self.agentInfo = {
        //   ...res,
        //   agentUserPincode: res.agentUserPincode ? String(res.agentUserPincode) : null,
        // }
        if (self.agentInfo.agentStatus !== AGENT_STATUS.ACTIVE) {
          const err = { message: 'Agent status is inactive.', code: self.agentInfo.agentStatus }
          RootStore.message.showErrDialog(err.message, 'CLOSE_WEBVIEW')
          throw err
        }
        return res
      } catch (err) {
        throw err
      }
    }),
    generateBeneOtpApi: flow(function* generateBeneOtpApi(mobileNumber: string) {
      try {
        const generateOtpReq = getOtpRequest(
          mobileNumber,
          self.agentInfo.mobileCountryCode,
          2
        )
        const res = yield generateOtp(self.session, generateOtpReq)
        console.log('deleteBeneOtpApi response:', res)
        return res
      } catch (err) {
        console.log('deleteBeneOtpApi error:', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getUniqueDeviceSessionApi: flow(function* getUniqueDeviceSessionApi() {
      try {
        const res = yield getUniqueDeviceSession(self.session, self.agentInfo.agentUserLoginId)
        self.session.deviceSessionId = res?.sessionToken
        // if (self.agentInfo.agentStatus !== AGENT_STATUS.ACTIVE) {
        //   const err = { message: 'Agent status is inactive.', code: self.agentInfo.agentStatus }
        //   throw err
        // }
        return res
      } catch (err) {
        throw err
      }
    }),
    sendUniqueDeviceSessionApi: flow(function* sendUniqueDeviceSessionApi(hash, agentID, timeStamp) {
      console.log('apicalleddd::')
      console.log('Debugging params in sendUniqueDeviceSessionApi:', { hash, agentID, timeStamp })
      try {
        console.log('beforeapicallll::')
        yield self.checkLocationWithRetries()
        const res = yield sendUniqueDeviceSession(
          self.session,
          self.agentInfo.agentUserLoginId,
          hash,
          agentID,
          timeStamp,
        )
        console.log(res, 'resscheccckkKK::')
        self.session.deviceSessionId = res?.sessionToken
        return res
      } catch (err) {
        RootStore.message.handleError(err)
        console.log(err, 'errerr:::::::')
        throw err
      }
    }),
    // sendUniqueDeviceSessionApi: flow(function* sendUniqueDeviceSessionApi() {
    //   console.log("apicalleddd::")
    //   try {
    //     const res = yield sendUniqueDeviceSession(self.session, self.agentInfo.agentUserLoginId)
    //     self.session.deviceSessionId = res?.sessionToken
    //     return res
    //   } catch (err) {
    //     throw err
    //   }
    // }),
    asyncAuthenticateAgent: flow(function* asyncAuthenticateAgent(
      fingerprintData: string,
      consent: string,
      fingerPrintDataAuthMode?: any,
    ) {
      try {
        const req = getAgentAuthenticationRquest(fingerprintData, consent, fingerPrintDataAuthMode)
        const res = yield authenticateOtp(self.session, req)
        self.agentInfo.authorizationCode = res.authorizationCode
        return res
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    updateSessionData: flow(function* updateSessionData() {
      try {
        const storedSession = yield (self as any)?.getStoredSessionData()
        self.session = { ...self.session, ...storedSession?.session }
        self.agentInfo.agentMobileNumber = storedSession?.agentMobileNumber
        console.log('htag in ', RootStore.consents.appType)
        console.log('htag in2 ', RootStore.consents.appType)
        RootStore.bcAppInfo.updateBCAppSessionData(
          storedSession?.session?.userAccessToken,
          storedSession?.session?.userIdentifierToken,
          '',
        )
      } catch (err) {
        console.log(err)
      }
    }),

    loadInitialsAsync: flow(function* loadInitalsAsync() {
      try {
        //yield delay(15000)
        //@ts-ignore
        //yield self.getAgentLocationInfo()
        yield (self as any)?.clearStoredSessionIfInvalid()
        const storedSession = yield (self as any)?.getStoredSessionData()
        const storedAgentLoginUserId = storedSession?.agentMobileNumber
        const storedAppType = storedSession?.appType
        console.log(storedSession, 'storedSession::')
        console.log(
          storedAgentLoginUserId,
          self?.agentInfo?.agentUserLoginId,
          storedAppType,
          RootStore.consents.appType,
          'startt::',
          storedAgentLoginUserId === self?.agentInfo?.agentUserLoginId,
          storedAppType === RootStore.consents.appType,
        )
        if (
          storedAgentLoginUserId === self?.agentInfo?.agentUserLoginId &&
          storedAppType === RootStore.consents.appType
        ) {
          yield (self as any)?.updateSessionData()
          console.log('afterupdatesession::')
          // yield self.getUniqueDeviceSessionApi(),
          yield Promise.all([
            self.getAgentUserInformationApi(),
            self.getUniqueDeviceSessionApi(),
            RootStore.consents.getConsentsApi(),
            RootStore.banks.getBankListApi(),
          ])
          console.log('beforeEauthverified:::')
          self.isAadhaarVarified = true
          console.log(self.isAadhaarVarified, 'checkeauthverified::')
        } else {
          yield self.session.appAuthenticateApi()
          console.log('eauthfailleedd:', RootStore.bcAppInfo.authenticationToken)
          // if (RootStore.bcAppInfo.authenticationToken) {
          const res = yield RootStore.bcAppInfo.userAuthenticateAsync()
          console.log(
            res.userAccessToken,
            res.userRefreshToken,
            res.userAccessTokenExpiry,
            res.userRefreshTokenExpiry,
            'checkrefreshaccesstoken::',
          )
          self.session.userAccessToken = res.userAccessToken
          self.session.userRefreshToken = res.userRefreshToken
          self.session.userAccessTokenExpiry = res.userAccessTokenExpiry
          self.session.userRefreshTokenExpiry = res.userRefreshTokenExpiry
          self.session.userIdentifierToken = res.userIdentifierToken
          RootStore.bcAppInfo.updateBCAppSessionData(res.userAccessToken, res.userIdentifierToken, '')
          if (RootStore.consents.appType !== '0') {
            yield self.storeSessionData()
          }
          // }

          yield Promise.all([
            self.getAgentUserInformationApi(),
            self.getUniqueDeviceSessionApi(),
            RootStore.consents.getConsentsApi(),
          ])
        }
      } catch (err) {
        console.log('htag ', err)
        //yield RootStore.agent.clearStoredSession()
        throw err
      }
      return {}
    }),
    clearStoredSessionIfInvalid: flow(function* clearStoredSessionIfInvalid() {
      const storedSession = yield (self as any)?.getStoredSessionData()
      const storedTimeStamp = storedSession?.currentTimeStamp
      const timeDiffInSeconds = (new Date().getTime() - storedTimeStamp) / 1000 + 60
      console.log('timeDiffInSeconds-', timeDiffInSeconds)
      console.log('storedSession?.session?.appRefreshTokenExpiry-', storedSession?.session?.appRefreshTokenExpiry)
      console.log('storedSession?.session?.userRefreshTokenExpiry-', storedSession?.session?.userRefreshTokenExpiry)
      if (
        Number.isNaN(timeDiffInSeconds) ||
        timeDiffInSeconds > storedSession?.session?.appRefreshTokenExpiry ||
        timeDiffInSeconds > storedSession?.session?.userRefreshTokenExpiry
      ) {
        yield RootStore.agent.clearStoredSession()
      }
    }),
    updateInitalAgentInfo: function updateInitalAgentInfo(
      CLIENT_ID: string,
      CHANNEL_ID: string,
      AGENT_ID: string,
      encToken: string,
      encKey: string,
      parentOrigin: string,
      transactionType: string,
      type: string,
    ) {
      console.log(CLIENT_ID, 'CLIENT_ID::::::')
      self.agentInfo.agentUserLoginId = AGENT_ID
      self.CLIENT_ID = CLIENT_ID
      self.session.CHANNEL_ID = CHANNEL_ID
      self.encToken = encToken
      self.encKey = encKey
      self.parentOrigin = parentOrigin
      self.transactionType = transactionType
      self.type = type
      console.log(
        self.transactionType,
        transactionType,
        self.type,
        type,
        encKey,
        self.encKey,
        self.parentOrigin,
        parentOrigin,
        self.encToken,
        encToken,
        AGENT_ID,
        CLIENT_ID,
        CHANNEL_ID,
        'checkclient and channelid:',
        self.agentInfo.agentUserLoginId,
        self.CLIENT_ID,
        self.session.CHANNEL_ID,
      )
      console.log(type, encToken, encKey, parentOrigin, transactionType, 'newcheckdatafrom epic:::')
    },
    getAgentUserLoginId: function getAgentUserLoginId() {
      return self.agentInfo.agentUserLoginId
    },
    generateOtpApi: flow(function* generateOtpApi() {
      const generateOtpReq = getOtpRequest(self.agentInfo.agentMobileNumber, self.agentInfo.mobileCountryCode, 1)
      const res = yield generateOtp(self.session, generateOtpReq).catch((err: any) => {
        console.log('generateOtpApires::', res)
        RootStore.message.handleError(err)
        throw err
      })
      return res
    }),
    generateOtpApiRefundAgent: flow(function* generateOtpApiRefundAgent() {
      const generateOtpReq = getOtpRequestRefund(self.agentInfo.agentMobileNumber, self.agentInfo.mobileCountryCode, 1)
      const res = yield generateOtp(self.session, generateOtpReq).catch((err: any) => {
        console.log('generateOtpApiRefundAgentres::', res)
        RootStore.message.handleError(err)
        throw err
      })
      return res
    }),

    authenticateOtpAndBiometricApi: flow(function* authenticateOtpAndBiometricApi(
      otp: string,
      fingerPrintData: string,
      consent: string,
      authMode: 'FACE' | 'FINGER_PRINT',
    ) {
      try {
        const req = getAuthenticateOtpForBiometric(
          otp,
          fingerPrintData,
          self.agentInfo.agentMobileNumber,
          self.agentInfo.agentUserLoginId,
          !self.agentInfo.aadhaar.tokenPresent ? self.agentInfo.aadhaar.token : '',
          self.agentInfo.aadhaar.tokenPresent ? self.agentInfo.aadhaar.token : '',
          self.agentInfo.agentUserName,
          consent,
          authMode,
        )
        console.log(self.agentInfo.aadhaar.token, 'aadhartokencheck::', self.agentInfo.aadhaar)
        const res = yield authenticateOtp(self.session, req)
        self.session.userAccessToken = res.userAccessToken
        self.session.userRefreshToken = res.userRefreshToken
        self.session.userAccessTokenExpiry = res.userAccessTokenExpiry
        self.session.userRefreshTokenExpiry = res.userRefreshTokenExpiry
        self.session.userIdentifierToken = res.userIdentifierToken
        self.agentInfo.aadhaar.UIDToken = res.UIDToken
        self.agentInfo.aadhaar.referenceNumber = res.referenceNumber
        self.agentInfo.aadhaar.jpbToken = res.jpbToken
        return res
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    authenticateOtpApi: flow(function* authenticateOtpApi(
      otp: string,
      mobileNumber = self.agentInfo.agentMobileNumber,
    ) {
      try {
        const req = getAuthenticateOtpForAgent(otp, mobileNumber)
        const res = yield authenticateOtp(self.session, req)
        self.session.userAccessToken = res.userAccessToken
        self.session.userRefreshToken = res.userRefreshToken
        self.session.userAccessTokenExpiry = res.userAccessTokenExpiry
        self.session.userRefreshTokenExpiry = res.userRefreshTokenExpiry
        self.session.userIdentifierToken = res.userIdentifierToken
        RootStore?.moneyTransferSession?.updateUserIdToken(res.userIdentifierToken)
        return res
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),

    addAgentUserIdentityApi: flow(function* addAgentUserIdentityApi() {
      const addAgentUserIdentityReq = getaddAgentRequest(self.agentInfo.agentUserLoginId, self.agentInfo.aadhaar.token)
      const res = yield addAgentUserIdentity(self.session, addAgentUserIdentityReq).catch((err: any) => {
        RootStore.message.handleError(err)
        throw err
      })
      return res
    }),

    asyncAuthenticateBiometric: flow(function* asyncAuthenticateBiometric(
      isFromEnterAadhaarCardScreen: boolean,
      otp: string,
      fingerPrintData: string,
      consent: string,
      authMode: 'FACE' | 'FINGER_PRINT',
    ) {
      try {
        //@ts-ignore
        yield self.authenticateOtpAndBiometricApi(otp, fingerPrintData, consent, authMode)
        if (isFromEnterAadhaarCardScreen) {
          //@ts-ignore
          yield self.addAgentUserIdentityApi()
        }
        yield RootStore.banks.getBankListApi()
        //@ts-ignore
        console.log('asyncfacefingerprint::')
        yield self.storeSessionData()
        const storedSession = yield (self as any)?.getStoredSessionData()
        const storedTimeStamp = storedSession?.currentTimeStamp
        const timeDiffInSeconds = (new Date().getTime() - storedTimeStamp) / 1000 + 60
        console.log('timeDiffInSecondsinauthh::-', timeDiffInSeconds)
        console.log('appRefreshTokenExpiry-', storedSession?.session?.appRefreshTokenExpiry)
        console.log('userRefreshTokenExpiry-', storedSession?.session?.userRefreshTokenExpiry)
      } catch (error) {
        console.log('handleerror::')
        throw error
      }
      return {}
    }),
    storeSessionData: flow(function* storeSessionData() {
      try {
        const appType = RootStore.consents.appType
        // if (RootStore.consents.appType === '0') {
        const { deviceSessionId, CHANNEL_ID, ...restSessionData } = self.session
        const appSessionData = JSON.stringify({
          agentUserLoginId: self?.agentInfo?.agentUserLoginId,
          agentMobileNumber: self?.agentInfo.agentMobileNumber,
          session: restSessionData,
          appType,
          currentTimeStamp: new Date().getTime(),
        })
        console.log(appSessionData, 'appSessionData::')
        window.localStorage.setItem('sessionData_' + appType, appSessionData)
        //  }
      } catch (e) {
        console.log('error while saving data', e)
      }
    }),
    getStoredTokenTime: flow(function* getStoredTokenTime() {
      try {
        const storedSessionData = window.localStorage.getItem('sessionData_' + RootStore.consents.appType)
        return JSON.parse(storedSessionData || '{}')?.currentTimeStamp || new Date().getTime()
      } catch (e) {
        console.log('error while fetching stored data', e)
        return new Date().getTime()
      }
    }),
    getStoredSessionData: flow(function* getStoredSessionData() {
      try {
        const storedSessionData = window.localStorage.getItem('sessionData_' + RootStore.consents.appType)
        return JSON.parse(storedSessionData || '{}')
      } catch (e) {
        console.log('error while fetching stored data', e)
        return {}
      }
    }),
    clearStoredSession: flow(function* clearStoredSession() {
      try {
        window.localStorage.removeItem('sessionData_' + RootStore.consents.appType)
      } catch (e) {
        console.log('error while clearing stored data', e)
      }
    }),
    updateAadhaarCardNumber: flow(function* updateAadhaarCardNumber(aadhaarNum: string) {
      self.agentInfo.aadhaar.token = aadhaarNum
    }),
    getAgentLocationInfo: flow(function* getAgentLocationInfo() {
      try {
        console.log('aeps timing firing location : ', new Date().toISOString())
        const loc = yield getLocation()
        console.log('aeps timing location received : ', new Date().toISOString())
        const latitude = loc?.coords?.latitude
        const longitude = loc?.coords?.longitude
        self.deviceInfo.latitude = String(latitude)
        self.deviceInfo.longitude = String(longitude)
        console.log('latitude ', latitude + '---' + longitude)
      } catch (error) {
        console.log('aeps timing location error : ', new Date().toISOString())
        console.log('Location error', error)
        //throw error
      }
    }),
    // getAgentLocationInfo: flow(function* getAgentLocationInfo(
    //   latitudeParam?: string,
    //   longitudeParam?: string,
    // ) {
    //   try {
    //     console.log()
    //     console.log('aeps timing firing location : ', new Date().toISOString())
    //     window.localStorage.getItem('ep_lat')
    //     window.localStorage.getItem('ep_long')
    //     console.log(window.localStorage.getItem('ep_lat'), "epiccclat")
    //     console.log(window.localStorage.getItem('ep_long'), "epiccclong")
    //     // const loc = yield getLocation()
    //     // console.log(loc, "locckech::")
    //     console.log('aeps timing location received : ', new Date().toISOString())
    //     // const latitude = loc?.coords?.latitude
    //     // const longitude = loc?.coords?.longitude
    //     const latitude = latitudeParam ? latitudeParam : window.localStorage.getItem('ep_lat')
    //     const longitude = longitudeParam ? longitudeParam : window.localStorage.getItem('ep_long')
    //     console.log(latitude, "servicelocationlatlong:::", longitude)
    //     self.deviceInfo.latitude = String(latitude)
    //     self.deviceInfo.longitude = String(longitude)
    //     console.log(self.deviceInfo, 'latitude', latitude + '---' + longitude)
    //     return { latitude, longitude };
    //   } catch (error) {
    //     console.log('aeps timing location error : ', new Date().toISOString())
    //     console.log('Location error', error)
    //     //throw error
    //   }
    // }),
    // fetchDeviceLocation: flow(function* fetchDeviceLocation() {
    //   try {
    //     console.log('Fetching device location...');
    //     const loc = yield getLocation();
    //     console.log(loc, "locckech::");
    //     if (loc?.coords?.latitude && loc?.coords?.longitude) {
    //       const latitude = String(loc.coords.latitude);
    //       const longitude = String(loc.coords.longitude);
    //       self.deviceInfo.latitude = latitude;
    //       self.deviceInfo.longitude = longitude;
    //       console.log('Device location updated:', latitude, longitude);
    //       return { latitude, longitude };
    //     } else {
    //       console.log('Failed to get device location. Coordinates are missing.');
    //       // Return an object with empty strings instead of nothing
    //       return { latitude: '', longitude: '' };
    //     }
    //   } catch (error) {
    //     console.log('Error fetching device location:', error);
    //     // Return an object with empty strings in case of an error
    //     return { latitude: '', longitude: '' };
    //   }
    // }),
    checkLocationWithRetries: flow(function* checkLocationWithRetries() {
      const MAX_LOCATION_RETRIES = 3
      let locationFound = false

      for (let i = 0; i < MAX_LOCATION_RETRIES; i++) {
        // Now this call will work because 'self' is typed to allow it.
        yield self.getAgentLocationInfo()
        if (self.deviceInfo.latitude && self.deviceInfo.longitude) {
          locationFound = true
          break
        }
        yield new Promise((resolve) => setTimeout(resolve, 1000))
      }

      if (!locationFound) {
        const error = {
          message: 'Failed to get location after multiple attempts. Please enable device location.',
          code: 'LOCATION_ERROR',
        }
        RootStore.message.handleError(error)
        throw error
      }
    }),
    setBioMetricDeviceInfo: flow(function* setBioMetricDeviceInfo(biometricDeviceInfo: string) {
      self.deviceInfo.biometricDeviceInfo = biometricDeviceInfo
    }),
    updateDeviceAppInfo: flow(function* updateDeviceAppInfo(appInfo: any) {
      console.log('appInfo', appInfo)
      self.deviceInfo.version = appInfo?.version
      self.deviceInfo.appId = appInfo?.appId
      self.deviceInfo.appName = appInfo?.appName
      self.deviceInfo.id = appInfo?.deviceId
      self.deviceInfo.ip = appInfo?.ip
      self.deviceInfo.osType = appInfo?.osType
      self.deviceInfo.osVer = appInfo?.osVer
      self.deviceInfo.model = appInfo?.model
      self.deviceInfo.sdkVersion = appInfo?.sdkVersion
    }),
    getAgentMetaDataWithAccDetails: flow(function* getAgentMetaDataWithAccDetails() {
      try {
        const response = yield getAgentBankDetails(self.session, self.agentInfo.agentUserLoginId)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    printReceipt: flow(function* printReceipt(txnId: string) {
      try {
        const download = yield downloadReceipt(RootStore?.agent?.session, txnId)
        return download
      } catch (error) {
        console.log('download failed')
      }
    }),
  }))
  .views((self) => ({
    isMaskedAadhaarAvailable: () => {
      return self?.agentInfo?.aadhaar && self?.agentInfo?.aadhaar?.tokenPresent && self?.agentInfo?.aadhaar?.token
    },
    getMaskedAadhaarCardNumber: () => {
      return (
        self?.agentInfo?.aadhaar?.maskedValue.replace(/^.{8}/g, 'xxxx xxxx ') ||
        self?.agentInfo?.aadhaar?.token.replace(/^.{8}/g, 'xxxx xxxx ')
      )
    },
    getMaskedMobileNo: () => {
      return self?.agentInfo?.agentMobileNumber.replace(/^.{6}/g, 'xxxxxx')
    },
  }))

const agentData = Agent.create({
  isAadhaarVarified: false,
  session: sessionData,
  agentInfo: { aadhaar: {} },
  deviceInfo: {},
})

export { Agent, agentData }

// import { getLocation } from '@jfs/utils'
// import { flow, types } from 'mobx-state-tree'
// import { AGENT_STATUS } from '../../AppContants'
// import { addAgentUserIdentity, getaddAgentRequest } from '../../network/addAgentUserIdentity'
// import {
//   authenticateOtp,
//   getAgentAuthenticationRquest,
//   getAuthenticateOtpForBiometric,
// } from '../../network/authenticateOtp'
// import { downloadReceipt } from '../../network/downloadReceipt'
// import { generateOtp, getOtpRequest, getOtpRequestRefund } from '../../network/generateOtp'
// import { getAgentBankDetails } from '../../network/getAgentBankDetails'
// import { getAgentUserInformation } from '../../network/getAgentUserInformation'
// import { getAgentUserInformationV3 } from '../../network/getAgentUserInformationV3'
// import { getUniqueDeviceSession } from '../../network/getUniqueDeviceSession'
// import { sendUniqueDeviceSession } from '../../network/sendUniqueDeviceSession'
// import { RootStore } from '../store'
// import { getAuthenticateOtpForAgent } from './../../network/authenticateOtp'
// import { Session, sessionData } from './Session'
// import { Instance } from 'mobx-state-tree'

// const Aadhaar = types.model('Aadhaar', {
//   tokenPresent: types.optional(types.boolean, false),
//   maskedValue: types.optional(types.string, ''),
//   token: types.optional(types.string, ''),
//   UIDToken: types.optional(types.string, ''),
//   referenceNumber: types.optional(types.string, ''),
//   jpbToken: types.maybeNull(types.string),
// })

// const AgentAuthorization = types.model('AgentAuthorization', {
//   function: types.optional(types.number, -1),
//   accountType: types.optional(types.number, -1),
//   accountHolderType: types.optional(types.number, -1),
//   kycType: types.optional(types.number, -1),
//   allowed: types.optional(types.boolean, false),
// })

// export const AgentInfo = types.model('AgentInfo', {
//   agentUserLoginId: types.optional(types.string, ''),
//   agentUserName: types.optional(types.string, ''),
//   gender: types.optional(types.number, -1),
//   dob: types.optional(types.string, ''),
//   parentOnboardingId: types.maybeNull(types.string),
//   agentMobileNumber: types.optional(types.string, ''),
//   agentEmailId: types.maybeNull(types.string),
//   mobileCountryCode: types.optional(types.number, 91),
//   agentStatus: types.optional(types.number, -1),
//   adminUser: types.optional(types.boolean, false),
//   agentAuthorization: types.maybeNull(types.array(AgentAuthorization)),
//   agentUserStateCode: types.maybeNull(types.string),
//   agentUserCity: types.maybeNull(types.string),
//   agentUserPincode: types.maybeNull(types.string),
//   agentUserRoleType: types.optional(types.number, -1),
//   agentUserDealershipName: types.optional(types.string, ''),
//   agentUserDealerCity: types.maybeNull(types.string),
//   agentUserDealerState: types.maybeNull(types.string),
//   agentUserDealerPinCode: types.maybeNull(types.string),
//   agentUserDealerStoreCode: types.maybeNull(types.string),
//   authorizationCode: types.maybeNull(types.string),
//   aadhaar: Aadhaar,
// })

// const AadhaarModelV3 = types.model('AadhaarModel', {
//   tokenPresent: types.maybeNull(types.boolean),
//   token: types.maybeNull(types.string),
//   maskedValue: types.maybeNull(types.string),
// })

// const AgentDetailsModelV3 = types.model('AgentDetailsModel', {
//   name: types.maybeNull(types.string),
//   id: types.maybeNull(types.string),
//   city: types.maybeNull(types.string),
//   stateCode: types.maybeNull(types.string),
//   pinCode: types.maybeNull(types.string),
//   latitude: types.maybeNull(types.number),
//   longitude: types.maybeNull(types.number),
//   storeCode: types.maybeNull(types.string),
//   parentAgentId: types.maybeNull(types.string),
//   organization: types.maybeNull(types.string),
//   authorization: types.maybeNull(types.string),
//   address: types.maybeNull(types.string),
// })

// export const AgentInfoV3Model = types.model('AgentInfoV3Model', {
//   externalUserId: types.maybeNull(types.string),
//   organizationName: types.maybeNull(types.string),
//   loginId: types.maybeNull(types.string),
//   name: types.maybeNull(types.string),
//   firstName: types.maybeNull(types.string),
//   middleName: types.maybeNull(types.string),
//   lastName: types.maybeNull(types.string),
//   gender: types.maybeNull(types.number), // Assuming 10 is an enum/code for gender
//   dob: types.maybeNull(types.string),
//   mobileNumber: types.maybeNull(types.string),
//   emailId: types.maybeNull(types.string),
//   countryCode: types.maybeNull(types.number),
//   status: types.maybeNull(types.number), // Assuming 10 is an enum/code for status
//   adminUser: types.maybeNull(types.boolean),
//   ekycStatus: types.maybeNull(types.boolean),
//   stateCode: types.maybeNull(types.string),
//   city: types.maybeNull(types.string),
//   pinCode: types.maybeNull(types.string),
//   createDate: types.maybeNull(types.string),
//   address: types.maybeNull(types.string),
//   agentUserActivationDate: types.maybeNull(types.string),
//   panAadharMatchPercentage: types.maybeNull(types.number),
//   panNumber: types.maybeNull(types.string),
//   agentUserSuspensionDate: types.maybeNull(types.string),
//   agentUserTerminationDate: types.maybeNull(types.string),
//   entityType: types.maybeNull(types.string),
//   subEntity: types.maybeNull(types.string),
//   parentAgentId: types.maybeNull(types.string),
//   parentMobileNo: types.maybeNull(types.string),
//   roles: types.array(types.frozen()), // Using frozen for an unknown array structure

//   // Nested objects
//   agent: types.maybeNull(AgentDetailsModelV3),
//   aadhaar: types.maybeNull(AadhaarModelV3),
//   appData: types.maybeNull(types.frozen()), // Use frozen for null/unknown object
// })

// export const DeviceInfo = types.model('DeviceInfo', {
//   latitude: types.optional(types.string, ''),
//   longitude: types.optional(types.string, ''),
//   version: types.optional(types.string, ''),
//   appId: types.optional(types.string, ''),
//   appName: types.optional(types.string, ''),
//   id: types.optional(types.string, ''),
//   ip: types.optional(types.string, ''),
//   osType: types.optional(types.string, ''),
//   osVer: types.optional(types.string, ''),
//   model: types.optional(types.string, ''),
//   sdkVersion: types.optional(types.string, ''),
//   biometricDeviceInfo: types.optional(types.string, '{}'),
// })

// const Agent = types
//   .model('Agent', {
//     isAadhaarVarified: types.optional(types.boolean, false),
//     session: Session,
//     agentInfo: AgentInfo,
//     agentInfoV3: AgentInfoV3Model,
//     CLIENT_ID: types.optional(types.string, ''),
//     deviceInfo: DeviceInfo,
//   })
//   .actions((self) => ({
//     updateIsAadhaarVarified: function updateIsAadhaarVarified() {
//       self.isAadhaarVarified = true
//       return true
//     },
//     updateAgentInfoV3(data: typeof AgentInfoV3Model.Type) {
//       self.agentInfoV3 = data // Assuming direct replacement is fine
//     },
//     // updateAgentInfoV3(data: any) {
//     //   console.log('DEBUG V3: START updateAgentInfoV3')
//     //   // Assuming 'data' contains fields relevant to V3, like agentId, clientId, etc.
//     //   self.agentInfoV3.agentUserLoginId = data?.agentUserLoginId || self.agentInfo.agentUserLoginId || ' '
//     //   self.agentInfoV3.agentUserName = data?.agentUserName || ' '
//     //   self.agentInfoV3.agentMobileNumber = data?.agentMobileNumber || ' '
//     //   self.agentInfoV3.agentEmailId = data?.agentEmailId || ' '
//     //   self.agentInfoV3.agentUserPincode = data?.agentUserPincode || ' '
//     //   self.agentInfoV3.gender = data?.gender || ' '
//     //   self.agentInfoV3.dob = data?.dob || ' '
//     //   self.agentInfoV3.parentOnboardingId = data?.parentOnboardingId || ' '
//     //   self.agentInfoV3.mobileCountryCode = data?.mobileCountryCode || ' '
//     //   self.agentInfoV3.agentStatus = data?.agentStatus || ' '
//     //   self.agentInfoV3.adminUser = data?.adminUser || ' '
//     //   self.agentInfoV3.agentAuthorization = data?.agentAuthorization || ' '
//     //   self.agentInfoV3.agentUserStateCode = data?.agentUserStateCode || ' '
//     //   self.agentInfoV3.agentUserCity = data?.agentUserCity || ' '
//     //   self.agentInfoV3.agentUserRoleType = data?.agentUserRoleType || ' '
//     //   self.agentInfoV3.agentUserDealershipName = data?.agentUserDealershipName || ' '
//     //   self.agentInfoV3.agentUserDealerCity = data?.agentUserDealerCity || ' '
//     //   self.agentInfoV3.agentUserDealerState = data?.agentUserDealerState || ' '
//     //   self.agentInfoV3.agentUserDealerPinCode = data?.agentUserDealerPinCode || ' '
//     //   self.agentInfoV3.agentUserDealerStoreCode = data?.agentUserDealerStoreCode || ' '
//     //   self.agentInfoV3.authorizationCode = data?.authorizationCode || ' '
//     //   self.agentInfoV3.aadhaar = data?.aadhaar || ' '
//     //   entityId: RootStore.agent.session.CHANNEL_ID || '3155',
//     //     // channelId: RootStore.agent.session.CHANNEL_ID || '3155',
//     //     // self.agentInfoV3.clientId = data?.clientId || self.CLIENT_ID
//     //     // self.agentInfoV3.channelId = RootStore.agent.session.CHANNEL_ID || '3155'
//     //     // self.agentInfoV3.agentStatusV3 = data?.status || 'ACTIVE'
//     //     console.log('DEBUG V3: AGENT V3 DATA stored:', JSON.stringify(self.agentInfoV3))
//     //   console.log('DEBUG V3: END updateAgentInfoV3')
//     // },

//     getAgentUserInformationApi: flow(function* getAgentUserInformationApi() {
//       try {
//         const res = yield getAgentUserInformation(self.session, self.agentInfo.agentUserLoginId)
//         self.agentInfo = res
//         if (self.agentInfo.agentStatus !== AGENT_STATUS.ACTIVE) {
//           const err = { message: 'Agent status is inactive.', code: self.agentInfo.agentStatus }
//           RootStore.message.showErrDialog(err.message, 'CLOSE_WEBVIEW')
//           throw err
//         }
//         return res
//       } catch (err) {
//         throw err
//       }
//     }),

//     getAgentUserInformationApiV3: flow(function* getAgentUserInformationApiV3() {
//       try {
//         const resV3 = yield getAgentUserInformationV3(self.session, self.agentInfo.agentUserLoginId)
//         // Ensure the response data structure matches AgentInfoV3 model
//         // In a real app, you might need a response parser here.
//         self.agentInfoV3 = resV3 // Directly assign the response
//         return resV3
//       } catch (err) {
//         throw err
//       }
//     }),

//     // getAgentUserInformationApiV3: flow(function* getAgentUserInformationApiV3() {
//     //   console.log('DEBUG V3: START getAgentUserInformationApiV3 flow')
//     //   console.log('DEBUG V3: Input Agent User Login ID:', self.agentInfo.agentUserLoginId)
//     //   // console.log('DEBUG V3: Session Token:', self.session.sessionToken);

//     //   const currentAppAccessToken = self.session.appAccessToken
//     //   console.log('DEBUG V3: Current App Access Token:', currentAppAccessToken)
//     //   // if (!currentAppAccessToken) {
//     //   //   const error = {
//     //   //     message: 'App Access Token is missing, skipping V3 fetch.',
//     //   //     code: 'TOKEN_MISSING_PRECHECK',
//     //   //   }
//     //   //   console.error('DEBUG V3 ERROR: Pre-check failed.', error)
//     //   // }
//     //   try {
//     //     console.log('DEBUG V3: Calling getAgentUserInformationV3 network function...')
//     //     const resV3 = yield getAgentUserInformationV3(self.session, self.agentInfo.agentUserLoginId)
//     //     console.log('DEBUG V3: Received API Response (resV3):', JSON.stringify(resV3))
//     //     self.agentInfoV3 = resV3
//     //     // ;(self as any).updateAgentInfoV3(resV3)
//     //     if (self.agentInfo.agentStatus !== AGENT_STATUS.ACTIVE) {
//     //       const err = { message: 'Agent status is inactive.', code: self.agentInfo.agentStatus }
//     //       RootStore.message.showErrDialog(err.message, 'CLOSE_WEBVIEW')
//     //       throw err
//     //     }
//     //     console.log('DEBUG V3: SUCCESSFULLY fetched and stored V3 data.')
//     //     return resV3
//     //   } catch (err) {
//     //     console.error('DEBUG V3 ERROR: Failed to fetch Agent V3 data via getAgentUserInformationApiV3', err)
//     //     throw err
//     //   } finally {
//     //     console.log('DEBUG V3: END getAgentUserInformationApiV3 flow')
//     //   }
//     // }),
//     getUniqueDeviceSessionApi: flow(function* getUniqueDeviceSessionApi() {
//       try {
//         const res = yield getUniqueDeviceSession(self.session, self.agentInfo.agentUserLoginId)
//         self.session.deviceSessionId = res?.sessionToken
//         // if (self.agentInfo.agentStatus !== AGENT_STATUS.ACTIVE) {
//         //   const err = { message: 'Agent status is inactive.', code: self.agentInfo.agentStatus }
//         //   throw err
//         // }
//         return res
//       } catch (err) {
//         throw err
//       }
//     }),
//     sendUniqueDeviceSessionApi: flow(function* sendUniqueDeviceSessionApi(hash, agentID, timeStamp) {
//       console.log('apicalleddd::')
//       console.log('Debugging params in sendUniqueDeviceSessionApi:', { hash, agentID, timeStamp })
//       try {
//         const res = yield sendUniqueDeviceSession(
//           self.session,
//           self.agentInfo.agentUserLoginId,
//           hash,
//           agentID,
//           timeStamp,
//         )
//         self.session.deviceSessionId = res?.sessionToken
//         return res
//       } catch (err) {
//         RootStore.message.handleError(err)
//         console.log(err, 'errerr:::::::')
//         throw err
//       }
//     }),
//     // sendUniqueDeviceSessionApi: flow(function* sendUniqueDeviceSessionApi() {
//     //   console.log("apicalleddd::")
//     //   try {
//     //     const res = yield sendUniqueDeviceSession(self.session, self.agentInfo.agentUserLoginId)
//     //     self.session.deviceSessionId = res?.sessionToken
//     //     return res
//     //   } catch (err) {
//     //     throw err
//     //   }
//     // }),
//     asyncAuthenticateAgent: flow(function* asyncAuthenticateAgent(
//       fingerprintData: string,
//       consent: string,
//       fingerPrintDataAuthMode?: any,
//     ) {
//       try {
//         const req = getAgentAuthenticationRquest(fingerprintData, consent, fingerPrintDataAuthMode)
//         const res = yield authenticateOtp(self.session, req)
//         self.agentInfo.authorizationCode = res.authorizationCode
//         return res
//       } catch (err) {
//         RootStore.message.handleError(err)
//         throw err
//       }
//     }),
//     updateSessionData: flow(function* updateSessionData() {
//       try {
//         const storedSession = yield (self as any)?.getStoredSessionData()
//         self.session = { ...self.session, ...storedSession?.session }
//         self.agentInfo.agentMobileNumber = storedSession?.agentMobileNumber
//         console.log('htag in ', RootStore.consents.appType)
//         console.log('htag in2 ', RootStore.consents.appType)
//         RootStore.bcAppInfo.updateBCAppSessionData(
//           storedSession?.session?.userAccessToken,
//           storedSession?.session?.userIdentifierToken,
//           '',
//         )
//       } catch (err) {
//         console.log(err)
//       }
//     }),

//     loadInitialsAsync: flow(function* loadInitalsAsync() {
//       try {
//         //yield delay(15000)
//         //@ts-ignore
//         //yield self.getAgentLocationInfo()
//         yield (self as any)?.clearStoredSessionIfInvalid()
//         const storedSession = yield (self as any)?.getStoredSessionData()
//         const storedAgentLoginUserId = storedSession?.agentMobileNumber
//         const storedAppType = storedSession?.appType
//         console.log(storedSession, 'storedSession::')
//         console.log(
//           storedAgentLoginUserId,
//           self?.agentInfo?.agentUserLoginId,
//           storedAppType,
//           RootStore.consents.appType,
//           'startt::',
//           storedAgentLoginUserId === self?.agentInfo?.agentUserLoginId,
//           storedAppType === RootStore.consents.appType,
//         )
//         if (
//           storedAgentLoginUserId === self?.agentInfo?.agentUserLoginId &&
//           storedAppType === RootStore.consents.appType
//         ) {
//           yield (self as any)?.updateSessionData()
//           console.log('afterupdatesession::')
//           yield self.getUniqueDeviceSessionApi(),
//             yield Promise.all([
//               self.getAgentUserInformationApi(),
//               // self.getAgentUserInformationApiV3(),
//               // self.getUniqueDeviceSessionApi(),
//               RootStore.consents.getConsentsApi(),
//               RootStore.banks.getBankListApi(),
//             ])
//           console.log('beforeEauthverified:::')
//           self.isAadhaarVarified = true
//           console.log(self.isAadhaarVarified, 'checkeauthverified::')
//         } else {
//           yield self.session.appAuthenticateApi()
//           console.log('eauthfailleedd:')
//           if (RootStore.bcAppInfo.authenticationToken) {
//             const res = yield RootStore.bcAppInfo.userAuthenticateAsync()
//             self.session.userAccessToken = res.userAccessToken
//             self.session.userRefreshToken = res.userRefreshToken
//             self.session.userAccessTokenExpiry = res.userAccessTokenExpiry
//             self.session.userRefreshTokenExpiry = res.userRefreshTokenExpiry
//             self.session.userIdentifierToken = res.userIdentifierToken
//             RootStore.bcAppInfo.updateBCAppSessionData(res.userAccessToken, res.userIdentifierToken, '')
//             if (RootStore.consents.appType !== '0') {
//               yield self.storeSessionData()
//             }
//           }

//           yield Promise.all([
//             self.getAgentUserInformationApi(),
//             // self.getAgentUserInformationApiV3(),
//             self.getUniqueDeviceSessionApi(),
//             RootStore.consents.getConsentsApi(),
//           ])
//         }
//       } catch (err) {
//         console.log('htag ', err)
//         //yield RootStore.agent.clearStoredSession()
//         throw err
//       }
//       return {}
//     }),
//     clearStoredSessionIfInvalid: flow(function* clearStoredSessionIfInvalid() {
//       const storedSession = yield (self as any)?.getStoredSessionData()
//       const storedTimeStamp = storedSession?.currentTimeStamp
//       const timeDiffInSeconds = (new Date().getTime() - storedTimeStamp) / 1000 + 60
//       console.log('timeDiffInSeconds-', timeDiffInSeconds)
//       console.log('storedSession?.session?.appRefreshTokenExpiry-', storedSession?.session?.appRefreshTokenExpiry)
//       console.log('storedSession?.session?.userRefreshTokenExpiry-', storedSession?.session?.userRefreshTokenExpiry)
//       if (
//         Number.isNaN(timeDiffInSeconds) ||
//         timeDiffInSeconds > storedSession?.session?.appRefreshTokenExpiry ||
//         timeDiffInSeconds > storedSession?.session?.userRefreshTokenExpiry
//       ) {
//         yield RootStore.agent.clearStoredSession()
//       }
//     }),
//     updateInitalAgentInfo: function updateInitalAgentInfo(CLIENT_ID: string, CHANNEL_ID: string, AGENT_ID: string) {
//       self.agentInfo.agentUserLoginId = AGENT_ID
//       self.CLIENT_ID = CLIENT_ID
//       self.session.CHANNEL_ID = CHANNEL_ID
//       console.log(
//         AGENT_ID,
//         CLIENT_ID,
//         CHANNEL_ID,
//         'checkclient and channelid:',
//         self.agentInfo.agentUserLoginId,
//         self.CLIENT_ID,
//         self.session.CHANNEL_ID,
//       )
//     },
//     getAgentUserLoginId: function getAgentUserLoginId() {
//       return self.agentInfo.agentUserLoginId
//     },
//     generateOtpApi: flow(function* generateOtpApi() {
//       const generateOtpReq = getOtpRequest(self.agentInfo.agentMobileNumber, self.agentInfo.mobileCountryCode, 1)
//       const res = yield generateOtp(self.session, generateOtpReq).catch((err: any) => {
//         console.log('generateOtpApires::', res)
//         RootStore.message.handleError(err)
//         throw err
//       })
//       return res
//     }),
//     generateOtpApiRefundAgent: flow(function* generateOtpApiRefundAgent() {
//       const generateOtpReq = getOtpRequestRefund(self.agentInfo.agentMobileNumber, self.agentInfo.mobileCountryCode, 1)
//       const res = yield generateOtp(self.session, generateOtpReq).catch((err: any) => {
//         console.log('generateOtpApiRefundAgentres::', res)
//         RootStore.message.handleError(err)
//         throw err
//       })
//       return res
//     }),

//     authenticateOtpAndBiometricApi: flow(function* authenticateOtpAndBiometricApi(
//       otp: string,
//       fingerPrintData: string,
//       consent: string,
//       authMode: 'FACE' | 'FINGER_PRINT',
//     ) {
//       try {
//         const req = getAuthenticateOtpForBiometric(
//           otp,
//           fingerPrintData,
//           self.agentInfo.agentMobileNumber,
//           self.agentInfo.agentUserLoginId,
//           !self.agentInfo.aadhaar.tokenPresent ? self.agentInfo.aadhaar.token : '',
//           self.agentInfo.aadhaar.tokenPresent ? self.agentInfo.aadhaar.token : '',
//           self.agentInfo.agentUserName,
//           consent,
//           authMode,
//         )
//         const res = yield authenticateOtp(self.session, req)
//         self.session.userAccessToken = res.userAccessToken
//         self.session.userRefreshToken = res.userRefreshToken
//         self.session.userAccessTokenExpiry = res.userAccessTokenExpiry
//         self.session.userRefreshTokenExpiry = res.userRefreshTokenExpiry
//         self.session.userIdentifierToken = res.userIdentifierToken
//         self.agentInfo.aadhaar.UIDToken = res.UIDToken
//         self.agentInfo.aadhaar.referenceNumber = res.referenceNumber
//         self.agentInfo.aadhaar.jpbToken = res.jpbToken
//         return res
//       } catch (err) {
//         RootStore.message.handleError(err)
//         throw err
//       }
//     }),
//     authenticateOtpApi: flow(function* authenticateOtpApi(
//       otp: string,
//       mobileNumber = self.agentInfo.agentMobileNumber,
//     ) {
//       try {
//         const req = getAuthenticateOtpForAgent(otp, mobileNumber)
//         const res = yield authenticateOtp(self.session, req)
//         self.session.userAccessToken = res.userAccessToken
//         self.session.userRefreshToken = res.userRefreshToken
//         self.session.userAccessTokenExpiry = res.userAccessTokenExpiry
//         self.session.userRefreshTokenExpiry = res.userRefreshTokenExpiry
//         self.session.userIdentifierToken = res.userIdentifierToken
//         RootStore?.moneyTransferSession?.updateUserIdToken(res.userIdentifierToken)
//         return res
//       } catch (err) {
//         RootStore.message.handleError(err)
//         throw err
//       }
//     }),

//     addAgentUserIdentityApi: flow(function* addAgentUserIdentityApi() {
//       const addAgentUserIdentityReq = getaddAgentRequest(self.agentInfo.agentUserLoginId, self.agentInfo.aadhaar.token)
//       const res = yield addAgentUserIdentity(self.session, addAgentUserIdentityReq).catch((err: any) => {
//         RootStore.message.handleError(err)
//         throw err
//       })
//       return res
//     }),

//     asyncAuthenticateBiometric: flow(function* asyncAuthenticateBiometric(
//       isFromEnterAadhaarCardScreen: boolean,
//       otp: string,
//       fingerPrintData: string,
//       consent: string,
//       authMode: 'FACE' | 'FINGER_PRINT',
//     ) {
//       try {
//         //@ts-ignore
//         yield self.authenticateOtpAndBiometricApi(otp, fingerPrintData, consent, authMode)
//         if (isFromEnterAadhaarCardScreen) {
//           //@ts-ignore
//           yield self.addAgentUserIdentityApi()
//         }
//         yield RootStore.banks.getBankListApi()
//         //@ts-ignore
//         console.log('asyncfacefingerprint::')
//         yield self.storeSessionData()
//         const storedSession = yield (self as any)?.getStoredSessionData()
//         const storedTimeStamp = storedSession?.currentTimeStamp
//         const timeDiffInSeconds = (new Date().getTime() - storedTimeStamp) / 1000 + 60
//         console.log('timeDiffInSecondsinauthh::-', timeDiffInSeconds)
//         console.log('appRefreshTokenExpiry-', storedSession?.session?.appRefreshTokenExpiry)
//         console.log('userRefreshTokenExpiry-', storedSession?.session?.userRefreshTokenExpiry)
//       } catch (error) {
//         console.log('handleerror::')
//         throw error
//       }
//       return {}
//     }),
//     storeSessionData: flow(function* storeSessionData() {
//       try {
//         const appType = RootStore.consents.appType
//         // if (RootStore.consents.appType === '0') {
//         const { deviceSessionId, CHANNEL_ID, ...restSessionData } = self.session
//         const appSessionData = JSON.stringify({
//           agentUserLoginId: self?.agentInfo?.agentUserLoginId,
//           agentMobileNumber: self?.agentInfo.agentMobileNumber,
//           session: restSessionData,
//           appType,
//           currentTimeStamp: new Date().getTime(),
//         })
//         console.log(appSessionData, 'appSessionData::')
//         window.localStorage.setItem('sessionData_' + appType, appSessionData)
//         //  }
//       } catch (e) {
//         console.log('error while saving data', e)
//       }
//     }),
//     getStoredTokenTime: flow(function* getStoredTokenTime() {
//       try {
//         const storedSessionData = window.localStorage.getItem('sessionData_' + RootStore.consents.appType)
//         return JSON.parse(storedSessionData || '{}')?.currentTimeStamp || new Date().getTime()
//       } catch (e) {
//         console.log('error while fetching stored data', e)
//         return new Date().getTime()
//       }
//     }),
//     getStoredSessionData: flow(function* getStoredSessionData() {
//       try {
//         const storedSessionData = window.localStorage.getItem('sessionData_' + RootStore.consents.appType)
//         return JSON.parse(storedSessionData || '{}')
//       } catch (e) {
//         console.log('error while fetching stored data', e)
//         return {}
//       }
//     }),
//     clearStoredSession: flow(function* clearStoredSession() {
//       try {
//         window.localStorage.removeItem('sessionData_' + RootStore.consents.appType)
//       } catch (e) {
//         console.log('error while clearing stored data', e)
//       }
//     }),
//     updateAadhaarCardNumber: flow(function* updateAadhaarCardNumber(aadhaarNum: string) {
//       self.agentInfo.aadhaar.token = aadhaarNum
//     }),
//     getAgentLocationInfo: flow(function* getAgentLocationInfo() {
//       try {
//         console.log('aeps timing firing location : ', new Date().toISOString())
//         const loc = yield getLocation()
//         console.log('aeps timing location received : ', new Date().toISOString())
//         const latitude = loc?.coords?.latitude
//         const longitude = loc?.coords?.longitude
//         self.deviceInfo.latitude = String(latitude)
//         self.deviceInfo.longitude = String(longitude)
//         console.log('latitude ', latitude + '---' + longitude)
//       } catch (error) {
//         console.log('aeps timing location error : ', new Date().toISOString())
//         console.log('Location error', error)
//         //throw error
//       }
//     }),
//     // getAgentLocationInfo: flow(function* getAgentLocationInfo(
//     //   latitudeParam?: string,
//     //   longitudeParam?: string,
//     // ) {
//     //   try {
//     //     console.log()
//     //     console.log('aeps timing firing location : ', new Date().toISOString())
//     //     window.localStorage.getItem('ep_lat')
//     //     window.localStorage.getItem('ep_long')
//     //     console.log(window.localStorage.getItem('ep_lat'), "epiccclat")
//     //     console.log(window.localStorage.getItem('ep_long'), "epiccclong")
//     //     // const loc = yield getLocation()
//     //     // console.log(loc, "locckech::")
//     //     console.log('aeps timing location received : ', new Date().toISOString())
//     //     // const latitude = loc?.coords?.latitude
//     //     // const longitude = loc?.coords?.longitude
//     //     const latitude = latitudeParam ? latitudeParam : window.localStorage.getItem('ep_lat')
//     //     const longitude = longitudeParam ? longitudeParam : window.localStorage.getItem('ep_long')
//     //     console.log(latitude, "servicelocationlatlong:::", longitude)
//     //     self.deviceInfo.latitude = String(latitude)
//     //     self.deviceInfo.longitude = String(longitude)
//     //     console.log(self.deviceInfo, 'latitude', latitude + '---' + longitude)
//     //     return { latitude, longitude };
//     //   } catch (error) {
//     //     console.log('aeps timing location error : ', new Date().toISOString())
//     //     console.log('Location error', error)
//     //     //throw error
//     //   }
//     // }),
//     // fetchDeviceLocation: flow(function* fetchDeviceLocation() {
//     //   try {
//     //     console.log('Fetching device location...');
//     //     const loc = yield getLocation();
//     //     console.log(loc, "locckech::");
//     //     if (loc?.coords?.latitude && loc?.coords?.longitude) {
//     //       const latitude = String(loc.coords.latitude);
//     //       const longitude = String(loc.coords.longitude);
//     //       self.deviceInfo.latitude = latitude;
//     //       self.deviceInfo.longitude = longitude;
//     //       console.log('Device location updated:', latitude, longitude);
//     //       return { latitude, longitude };
//     //     } else {
//     //       console.log('Failed to get device location. Coordinates are missing.');
//     //       // Return an object with empty strings instead of nothing
//     //       return { latitude: '', longitude: '' };
//     //     }
//     //   } catch (error) {
//     //     console.log('Error fetching device location:', error);
//     //     // Return an object with empty strings in case of an error
//     //     return { latitude: '', longitude: '' };
//     //   }
//     // }),
//     checkLocationWithRetries: flow(function* checkLocationWithRetries() {
//       const MAX_LOCATION_RETRIES = 3
//       let locationFound = false

//       for (let i = 0; i < MAX_LOCATION_RETRIES; i++) {
//         // Now this call will work because 'self' is typed to allow it.
//         yield self.getAgentLocationInfo()
//         if (self.deviceInfo.latitude && self.deviceInfo.longitude) {
//           locationFound = true
//           break
//         }
//         yield new Promise((resolve) => setTimeout(resolve, 1000))
//       }

//       if (!locationFound) {
//         const error = {
//           message: 'Failed to get location after multiple attempts. Please enable device location.',
//           code: 'LOCATION_ERROR',
//         }
//         RootStore.message.handleError(error)
//         throw error
//       }
//     }),
//     setBioMetricDeviceInfo: flow(function* setBioMetricDeviceInfo(biometricDeviceInfo: string) {
//       self.deviceInfo.biometricDeviceInfo = biometricDeviceInfo
//     }),
//     updateDeviceAppInfo: flow(function* updateDeviceAppInfo(appInfo: any) {
//       console.log('appInfo', appInfo)
//       self.deviceInfo.version = appInfo?.version
//       self.deviceInfo.appId = appInfo?.appId
//       self.deviceInfo.appName = appInfo?.appName
//       self.deviceInfo.id = appInfo?.deviceId
//       self.deviceInfo.ip = appInfo?.ip
//       self.deviceInfo.osType = appInfo?.osType
//       self.deviceInfo.osVer = appInfo?.osVer
//       self.deviceInfo.model = appInfo?.model
//       self.deviceInfo.sdkVersion = appInfo?.sdkVersion
//     }),
//     getAgentMetaDataWithAccDetails: flow(function* getAgentMetaDataWithAccDetails() {
//       try {
//         const response = yield getAgentBankDetails(self.session, self.agentInfo.agentUserLoginId)
//         return response
//       } catch (err) {
//         RootStore.message.handleError(err)
//         throw err
//       }
//     }),
//     printReceipt: flow(function* printReceipt(txnId: string) {
//       try {
//         const download = yield downloadReceipt(RootStore?.agent?.session, txnId)
//         return download
//       } catch (error) {
//         console.log('download failed')
//       }
//     }),
//   }))
//   .views((self) => ({
//     isMaskedAadhaarAvailable: () => {
//       return self?.agentInfo?.aadhaar && self?.agentInfo?.aadhaar?.tokenPresent && self?.agentInfo?.aadhaar?.token
//     },
//     getMaskedAadhaarCardNumber: () => {
//       return (
//         self?.agentInfo?.aadhaar?.maskedValue.replace(/^.{8}/g, 'xxxx xxxx ') ||
//         self?.agentInfo?.aadhaar?.token.replace(/^.{8}/g, 'xxxx xxxx ')
//       )
//     },
//     getMaskedMobileNo: () => {
//       return self?.agentInfo?.agentMobileNumber.replace(/^.{6}/g, 'xxxxxx')
//     },
//   }))

// const agentData = Agent.create({
//   isAadhaarVarified: false,
//   session: sessionData,
//   agentInfo: { aadhaar: {} },
//   deviceInfo: {},
// })

// export { Agent, agentData }
